import React, { useEffect, useState } from 'react';
import { getPermission } from '../../Conexiones/Conexion';
import CarObra from './CarObra';
import '../../CSS/Herramientas.css'
import { useNavigate } from "react-router";
import { BsPlus } from "react-icons/bs";
import { GoGraph } from "react-icons/go";
import ResumenProyecto from './ResumenProyecto';
import { FaArrowLeftLong } from 'react-icons/fa6';
import { getApi, postApiImg } from '../../Conexiones/Models';
import { errorMessage, errorToast, successToast, warningToast } from '../../Utils/AlertMessage';
import { Button, CloseButton, Modal } from 'react-bootstrap';
import Select from 'react-select';
import Loading from '../../Utils/Loading';

function Obras() {
    const [obras, setObras] = useState([]);
    const [proyecto, setProyecto] = useState('');
    const navigate = useNavigate()
    const numProyecto=parseInt(sessionStorage.getItem("proyecto"));
    const usuario = JSON.parse(sessionStorage.getItem('user')) 
    const idUsuario = usuario[0].idUsuario
    const uri = 'obras-proyectos/';
    const [isLoading,setIsLoading]=useState(false);
    
    useEffect(() => {
        const getObras = async () => {
            setIsLoading(true);
            const permiso = await getPermission(idUsuario,17);
            if(permiso){
                const endpoint = uri + numProyecto;
                const res = await getApi(endpoint);
                if(res.status === 1){
                    if(res.data.length !== undefined){
                        setObras(res.data[0].obras);
                        setProyecto(res.data[0].proyecto);
                    }else{
                        errorMessage(res.data.message);
                    }
                }else if(res.status === 210){
                    navigate('/');
                }else{
                    errorMessage(res.message);
                }
            }else{
                navigate('/inicio')
            }
            setIsLoading(false);
          };
        getObras();
    }, [navigate,idUsuario,numProyecto]);

    const getObras = async () => {
        const endpoint = uri + numProyecto;
        const res = await getApi(endpoint);
        if(res.status === 1){
            if(res.data.length !== undefined){
                setObras(res.data[0].obras);
                setProyecto(res.data[0].proyecto);
            }else{
                errorMessage(res.data.message);
            }
        }else if(res.status === 210){
            navigate('/');
        }else{
            errorMessage(res.message);
        }
    };

    const regresar = () => {
        navigate('/inicio/Proyectos')
    }

    const [obrasTipos,setObrasTipos]=useState([])
    const getTipos = async () =>{
        const endpoint = 'tiposObra/';
        const res = await getApi(endpoint);
        if(res.status === 1){
            if(res.data.length !== undefined){
                setObrasTipos(res.data);
            }else{
                errorMessage(res.data.message);
            }
        }else if(res.status === 210){
            navigate('/');
        }else{
            errorMessage(res.message);
        }
    }

    //Agregar Obra
    const [nombreObra,setNombreObra]=useState('')
    const [direcObra,setdirecObra]=useState('')
    const [cliente,setCliente]=useState('')
    const [fechaInicio,setFechaI]=useState('')
    const [fechaFinal,setFechaF]=useState('')
    const [tipo,setTipo]=useState('')
    const [imgObra,setimagenObra]=useState(null)
    const [pisos,setPisos]=useState('')
    const [isSaving, setSaving] = useState(false);
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const handleCloseAdd = () => {
        handleClose();
        setNombreObra('');
        setdirecObra('');
        setCliente('');
        setFechaI('');
        setFechaF('');
        setTipo('');
        setimagenObra(null);
        setPisos('');
    }
    const handleShowAdd = async () => {
        await getTipos();
        handleShow();
    }
    const handleSelecTipo = (event) =>{
        setTipo(event.value)
    }
    const store = async (e) =>{
        setSaving(true);
        e.preventDefault()
        if(nombreObra.trim().length === 0 | direcObra.trim().length === 0 | cliente.trim().length === 0 | tipo === ''){
            warningToast('CAMPOS VACIOS');
        }else{
            const idTipo= parseInt(tipo)
            const formdata = new FormData();
            formdata.append("image", imgObra);
            formdata.append("name", nombreObra);
            formdata.append("direccion", direcObra);
            formdata.append("cliente", cliente);
            formdata.append("fechaI", fechaInicio);
            formdata.append("fechaF", fechaFinal);
            formdata.append("tipo", idTipo);
            formdata.append("pisos", pisos);
            formdata.append("idProyecto",numProyecto);
            const endpoint = 'obras/';
            const res = await postApiImg(endpoint,formdata);
            if(res.status === 1){
                if(res.data.message==="¡Registro creado correctamente!"){
                    handleCloseAdd();
                    getObras();
                    successToast("AGREGADO");
                }else{
                    errorToast("¡ERROR!",res.data.message);
                }
            }else if(res.status === 210){
                navigate('/');
            }else{
                errorMessage(res.message);
            }
        }
        setSaving(false);
    }

    //Resumen
    const [showR, setShowR] = useState(false);
    const handleCloseR = () => setShowR(false);
    const handleShowR = () => setShowR(true);
    const [resumen,setResumen] = useState([]);
    const showResumen = async () =>{
        const endpoint = 'resumen-proyectos/' + numProyecto;
        const res = await getApi(endpoint);
        if(res.status === 1){
            if(res.data.length !== undefined){
                setResumen(res.data);
                handleShowR();
            }else{
                errorMessage(res.data.message);
            }
        }else if(res.status === 210){
            navigate('/');
        }else{
            errorMessage(res.message);
        }
    }
    
    return (
        <div className='herramientas' >
            {
                isLoading ? 
                <Loading />:
                <div>
                    <ResumenProyecto show={showR} handleClose={handleCloseR} nombre={proyecto} total={resumen}/>
                    <div className='contabilidades-header'>
                        <div className='fab'><FaArrowLeftLong className='arrow' onClick={regresar} title='REGRESAR'/></div>
                        <label className="text-uppercase">{proyecto === "" ? "":`obras de ${proyecto}`}</label>
                    </div>
                    <div className='divbotonE' >
                        {
                            idUsuario === 185 ?
                            null :
                            <div className='botonE'>
                                <button style={{justifyContent:'center'}}  className="btn btn-light btncolor" onClick={handleShowAdd} type="button">
                                    <label className="agregar">OBRA</label><BsPlus style={{fontSize:'25px'}}/>
                                </button>
                                <button style={{justifyContent:'center'}}  className="btn btn-light btncolor" onClick={showResumen} type="button">
                                    <label className="agregar">RESUMEN</label><GoGraph style={{fontSize:'25px',paddingLeft:"10px"}}/>
                                </button>
                            </div>
                        }
                        
                    </div>
                    {
                    obras.length === 0 ? (<h3 style={{marginTop:'30vh'}}>AUN NO HAY REGISTROS</h3>):(
                            <div className="categorias" >
                                <div className="row row-cols-1 row-cols-md-4 g-4" >
                                    {//Restablecer
                                        idUsuario === 185 ?
                                        obras.map(o =>
                                            o.idObra === 45 ?
                                            <div className="col-sm-6 mb-3 mb-sm-0 " key={o.idObra}>
                                                <CarObra  titulo={o.nombreObra} id={o.idObra}
                                                imagen={o.imagenObra} direccion={"/Lista-Obras/Administracion-Obras"} proyectoNull={o.proyecto}/>
                                            </div> : null
                                            
                                        ) :
                                        obras.map(o =>{
                                            return(                    
                                                <div className="col-sm-6 mb-3 mb-sm-0 " key={o.idObra}>
                                                    <CarObra  titulo={o.nombreObra} id={o.idObra}
                                                    imagen={o.imagenObra} direccion={"/Lista-Obras/Administracion-Obras"} proyectoNull={o.proyecto}/>
                                                </div>
                                            )           
                                        })
                                    }
                                    {/* obras.map(o =>{
                                        return(                    
                                            <div className="col-sm-6 mb-3 mb-sm-0 " key={o.idObra}>
                                                <CarObra  titulo={o.nombreObra} id={o.idObra}
                                                imagen={o.imagenObra} direccion={"/Lista-Obras/Administracion-Obras"} proyectoNull={o.proyecto}/>
                                            </div>
                                        )           
                                    }) */}            
                                </div>
                            </div>
                        )
                    }

                    {/*AGREGAR PROYECTO/OBRA*/}
                    <Modal show={show} onHide={handleClose}  id="modal-agregar-obra" >
                        <Modal.Header className=' btncolor'>
                            <Modal.Title>AGREGAR OBRA</Modal.Title>
                            <CloseButton onClick={handleCloseAdd} style={{backgroundColor:"white"}} />
                        </Modal.Header>
                        <Modal.Body  style={{textAlign:'left', height:'60vh', overflowY:"scroll" }}>
                            <div className="divO">
                                <label className="obligatorio">Obligatorio *</label>  
                            </div>
                            <div className="mb-3">
                                <label htmlFor="exampleFormControlInput1" className="text-uppercase" > nombre de la obra</label>
                                <input type="text" className="form-control" onChange={(e)=>setNombreObra(e.target.value)}  aria-describedby="basic-addon1"/>   
                            </div>
                            <div className=" mb-3">
                                <label htmlFor="exampleFormControlInput1" className="text-uppercase" >dirección</label>
                                <input type="text" className="form-control" onChange={(e)=>setdirecObra(e.target.value)}  aria-describedby="basic-addon1"/>   
                            </div>
                            <div className=" mb-3">
                                <label htmlFor="exampleFormControlInput1" className="text-uppercase" >cliente</label>
                                <input type="text" className="form-control" onChange={(e)=>setCliente(e.target.value)}  aria-describedby="basic-addon1"/>   
                            </div>
                            <div className=" mb-3">
                                <label htmlFor="exampleFormControlInput1" className="text-uppercase" >fecha de inicio</label>
                                <input type="date" className="form-control" onChange={(e)=>setFechaI(e.target.value)}    aria-describedby="basic-addon1"/>   
                            </div>
                            <div className=" mb-3">
                                <label htmlFor="exampleFormControlInput1" className="text-uppercase" >fecha  final</label>
                                <input type="date" className="form-control" onChange={(e)=>setFechaF(e.target.value)}    aria-describedby="basic-addon1"/>   
                            </div>
                            <div className="mb-3">
                                <label htmlFor="exampleFormControlInput1" className="text-uppercase" > tipo de obra</label>
                                <Select
                                    classNamePrefix="select"
                                    placeholder="Selecciona un tipo de obra..."
                                    required
                                    options={obrasTipos.map(t=>({label:t.nombreTipoObra,value:t.idTipoObra}))}
                                    onChange={handleSelecTipo}
                                />
                            </div>
                            <div className=" mb-3">
                                <label htmlFor="exampleFormControlInput1" className="text-uppercase" >pisos</label>
                                <input className="form-control" type="number" min={0} onChange={(e)=>setPisos(e.target.value)}  />
                            </div>
                            <div className=" mb-3">
                                <label htmlFor="exampleFormControlInput1" className="text-uppercase" >imagen</label>
                                <input className="form-control" type="file"  onChange={(e)=>setimagenObra(e.target.files[0])}  />
                            </div>
                            <div className=" mb-3">
                                <div style={{textAlign:"center", padding:'10px'}}>
                                    <img src={imgObra === null ? null:URL.createObjectURL(imgObra)} width={'50%'} alt={nombreObra}/>
                                </div>
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button type="button" className="btn btn-secondary" onClick={handleCloseAdd}>CANCELAR</Button>                                               
                                { isSaving===true? 
                                    <Button className="btn btn-primary" type="button" disabled >
                                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                        Loading...
                                    </Button>:
                                    <Button type="button" className="btn btn-light btncolor" onClick={store} >GUARDAR CAMBIOS</Button>
                                }
                        </Modal.Footer>
                    </Modal>
                </div>
            }
        </div>
    );
}

export default Obras;